// extracted by mini-css-extract-plugin
export var banner = "_iu-0";
export var closeButton = "_iu-2";
export var greenCheckmark = "_iu-3";
export var hereLink = "_iu-4";
export var titleIcon = "_iu-1";